import React from "react";
import { TID } from "@/constants/testIds";
import { COPY } from "@/copy";

export const Header = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid={TID.header}
      className="sticky top-0 z-50 bg-ds-bone ds-border border-l-0 border-r-0 border-t-0"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <button
          data-testid={TID.brand}
          onClick={() => scrollTo("top")}
          className="ds-display text-2xl hover:text-ds-flame transition-colors"
        >
          DateSpeak<span className="text-ds-flame">.</span>
        </button>

        <nav className="hidden md:flex items-center gap-8 ds-mono text-xs">
          <button data-testid={TID.navDecode} onClick={() => scrollTo("decoder")} className="hover:text-ds-flame transition-colors uppercase tracking-widest">
            {COPY.nav_decode}
          </button>
          <button data-testid={TID.navHow} onClick={() => scrollTo("how")} className="hover:text-ds-flame transition-colors uppercase tracking-widest">
            {COPY.nav_how}
          </button>
          <button data-testid={TID.navFups} onClick={() => scrollTo("fups")} className="hover:text-ds-flame transition-colors uppercase tracking-widest">
            {COPY.nav_fups}
          </button>
        </nav>

        <button
          onClick={() => scrollTo("decoder")}
          className="ds-border bg-ds-ink text-ds-bone px-4 py-1.5 ds-mono text-xs uppercase tracking-widest hover:bg-ds-flame hover:text-ds-ink transition-colors"
        >
          Decode →
        </button>
      </div>
    </header>
  );
};
